/* eslint-disable @next/next/no-sync-scripts */

import { TogetherDataTransforms } from '@hhgtech/hhg-components/together'
import flatten from 'lodash/flatten'
import sortBy from 'lodash/sortBy'

import { callApiNew } from 'api/axios'
import { formatCareDoctorInfo } from 'api/dataTransform'
import { formatTopServices } from 'api/dataTransform/carePath'
import { ecommerceDataFormatter } from 'api/dataTransform/ecommerce'
import { PATHS } from 'api/paths'
import type {
  Spotlight,
  SpotlightCommunityWithPostsSession,
  SpotlightEcommerceProductsSession,
  SpotlightEmbeddingDoctorsSession,
} from 'interfaces/types'
import {
  SessionType,
  SpotlightCommunityWithPostEmbedType,
} from 'interfaces/types'

export const handleFetchMoreData = async (spotLightFormatted: Spotlight) => {
  const resData = await Promise.all(
    spotLightFormatted.listSessions.map((session) => {
      if (session.sessionLayout === SessionType.EMBEDDING_DOCTORS) {
        const i = session as SpotlightEmbeddingDoctorsSession
        return (i.embebIds || [].length > 0) &&
          i.typeEmbedding === 'top_service'
          ? callApiNew(
              PATHS.CARE.GET_TOP_SERVICES,
              {
                params: {
                  categoryIds: i.embebIds.join(','),
                },
              },
              'care',
            )
          : i.typeEmbedding === 'doctors' || i.typeEmbedding === 'specialties'
          ? callApiNew(
              PATHS.CARE.GET_SEARCH_CARE,
              {
                params: {
                  type: 'doctor',
                  page: 1,
                  perPage: 12,
                  ...(i.typeEmbedding === 'doctors' && {
                    doctorIds: i.embebIds.join(','),
                  }),
                  ...(i.typeEmbedding === 'specialties' &&
                    i.embebIds.length > 0 && {
                      specialtyId: i.embebIds.join(','),
                      isCarePath: Number(
                        spotLightFormatted.postName === 'care-path',
                      ),
                    }),
                },
              },
              'careV2',
            )
          : undefined
      } else if (session.sessionLayout === SessionType.ECOMMERCE_PRODUCS) {
        const i = session as SpotlightEcommerceProductsSession
        return callApiNew(
          PATHS.ECOMMERCE.GET_PRODUCT_DETAIL_BY_LIST_IDS,
          {
            params: {
              skuList: i.productSkuList.replace(/ /g, ''),
            },
          },
          'ecommerce',
        )
      } else if (session.sessionLayout === SessionType.COMMUNITY_WITH_POSTS) {
        const i = session as SpotlightCommunityWithPostsSession
        return i.typeEmbed === SpotlightCommunityWithPostEmbedType.POST &&
          i.postsIds.length > 0
          ? callApiNew(
              PATHS.TOGETHER.GET_TOGETHER_POST_LIST,
              {
                method: 'GET',
                params: {
                  includeIds: i.postsIds.join(','),
                },
              },
              'together',
            )
          : i.typeEmbed === SpotlightCommunityWithPostEmbedType.COMMUNITY &&
            i.communityId
          ? callApiNew(
              PATHS.TOGETHER.GET_TOGETHER_COMMUNITY_DETAIL,
              {
                method: 'GET',
                params: {
                  communityId: i.communityId,
                },
              },
              'together',
            )
          : i.typeEmbed === SpotlightCommunityWithPostEmbedType.MINIGAME &&
            i.post
          ? callApiNew(
              PATHS.TOGETHER.GET_TOGETHER_POST_DETAIL,
              {
                method: 'GET',
                params: {
                  idOrSlug: i.post,
                },
              },
              'together',
            )
          : undefined
      }
      return undefined
    }),
  )
  const newSpotLightFormatted = { ...spotLightFormatted }
  spotLightFormatted.listSessions.map((i, idx) => {
    if (i.sessionLayout === SessionType.EMBEDDING_DOCTORS) {
      const session = i as SpotlightEmbeddingDoctorsSession
      const res = resData[idx] as any
      ;(newSpotLightFormatted.listSessions[
        idx
      ] as SpotlightEmbeddingDoctorsSession).doctors =
        session.typeEmbedding === 'top_service'
          ? sortBy(
              flatten(
                formatTopServices(res?._data?.top_services).serviceList.map(
                  (j) => j.services,
                ),
              ),
              ['position'],
              'asc',
            )
          : sortBy(
              (res?._data?.searches || []).map(formatCareDoctorInfo),
              ['position'],
              'asc',
            )
    } else if (i.sessionLayout === SessionType.ECOMMERCE_PRODUCS) {
      ;(newSpotLightFormatted.listSessions[
        idx
      ] as SpotlightEcommerceProductsSession).products = (
        resData[idx]?.data?.products || []
      ).map(ecommerceDataFormatter.formatProduct)
    } else if (i.sessionLayout === SessionType.COMMUNITY_WITH_POSTS) {
      const session = i as SpotlightCommunityWithPostsSession
      session.typeEmbed === SpotlightCommunityWithPostEmbedType.POST
        ? ((newSpotLightFormatted.listSessions[
            idx
          ] as SpotlightCommunityWithPostsSession).posts = (
            resData[idx]?.data?.posts || []
          ).map(TogetherDataTransforms.formatPost))
        : session.typeEmbed === SpotlightCommunityWithPostEmbedType.COMMUNITY
        ? ((newSpotLightFormatted.listSessions[
            idx
          ] as SpotlightCommunityWithPostsSession).community = TogetherDataTransforms.formatCommunity(
            resData[idx]?.data || {},
          ))
        : session.typeEmbed === SpotlightCommunityWithPostEmbedType.MINIGAME &&
          resData[idx]?.data
        ? ((newSpotLightFormatted.listSessions[
            idx
          ] as SpotlightCommunityWithPostsSession).postDetail = TogetherDataTransforms.formatPost(
            resData[idx].data || {},
          ))
        : null
    }
  })
  return newSpotLightFormatted
}
